import React from "react";
import { Button } from "react-bootstrap";

function ModalLinkButton({ title, href, addClass, target, linkout, download, onClick }) {
	return (
		<Button
			title={title}
			className={addClass}
			href={href}
			target={target}
			onClick={onClick}
		>
			<span>{title}</span>
		</Button>
	);
}

export default ModalLinkButton;
